import { useMutation, useQueryClient } from '@tanstack/react-query';
import getFetchWrapper from '../helpers/getFetchWrapperWithTrackingId';
import { planQuestionnaireEligibilityUrl, settlementEligibilityCheckUrl } from '../const/api-endpoints';
import { HttpMethod } from '../const/http-method';
import { useMainContext } from '../context';
import { onInvalidate } from '../helpers/enrollment';
import { planEligibilityCheckCacheKey } from './use-plan-eligibility-check';
export var getSubmitPlanQuestionnaireCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [planQuestionnaireEligibilityUrl, { accountId: accountId, accountIdType: accountIdType }];
};
var useSubmitPlanQuestionnaire = function (questionIdAndAnswer) {
    var _a = useMainContext(), accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config;
    var fetchWrapper = getFetchWrapper(config, accountId);
    var queryClient = useQueryClient();
    return useMutation({
        mutationKey: getSubmitPlanQuestionnaireCacheKey({
            accountId: accountId,
            accountIdType: accountIdType
        }),
        mutationFn: function () {
            return fetchWrapper(planQuestionnaireEligibilityUrl, {
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: accountIdType,
                    questionIdAndAnswer: questionIdAndAnswer
                }),
                method: HttpMethod.POST
            });
        },
        onError: function (err) {
            onInvalidate({
                cacheKey: planEligibilityCheckCacheKey({ accountId: accountId, accountIdType: accountIdType }),
                queryClient: queryClient
            });
            throw err;
        },
        onSuccess: function () {
            onInvalidate({
                cacheKey: [settlementEligibilityCheckUrl, { accountId: accountId, accountIdType: accountIdType }],
                queryClient: queryClient
            });
        }
    });
};
export default useSubmitPlanQuestionnaire;
//# sourceMappingURL=use-submit-plan-questionnaire.js.map